import { RM04 } from "./RM04";
import { RM07 } from "./RM07";
import { RM08 } from "./RM08";
import { RM09 } from "./RM09";
import { RM10 } from "./RM10";
import { RM11 } from "./RM11";
import { RM12 } from "./RM12";

export const RegionCoverageOverviewReport = {
  sections: [
    RM08,
    RM07,
    RM09,
    RM10,
    RM11,
    RM12,
    RM04
  ],
};
